import { useMemo } from 'react'

import getCustomerTokenHeaderObject from './getCustomerTokenHeaderObject'
import { useLoginTokenContext } from './LoginTokenContext'

export function useAuthorizationContext() {
  // get the authentication token from local storage if it exists
  const context = useLoginTokenContext()
  const token = context()

  return useMemo(() => getCustomerTokenHeaderObject(token), [token])
}
